import Content from './Content/Content'
import Options from './Options/Options'


const ProfileDataContainer = () => {

    return (
        <>
            <Content />
            <Options />
        </>
    )
}

export default ProfileDataContainer